import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetPurchases = async (params: {
  page: number;
  limit: number;
  search?: string;
  supplier_id?: string | null;
  status?: string | null;
  payment_status?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/purchases`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load purchases.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetPurchaseById = async (
  id: number | string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/purchases/id`, {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load purchase details.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreatePurchase = async (
  payload: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/purchases/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create purchase.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdatePurchase = async (
  payload: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/purchases/update`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update purchase.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeletePurchase = async (
  id: number | string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/purchases/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete purchase.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const ScanInvoice = async (
  base64Data: string,
  mimeType: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/purchases/scan-invoice`, {
      base64_data: base64Data,
      mime_type: mimeType,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to scan invoice with AI.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const ReturnPurchase = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/purchases/return`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to return purchase.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
